module.exports = __webpack_public_path__ + "static/media/Price199Pro.4623c5a3.svg";